import React from 'react';

import { I18n } from '@interlayer/js/components/common/I18n';

import { useTranslations } from '@core/js/hooks/i18n';
import { clsb } from '@core/js/utils/classNames.util';

import { TNumberCardProps } from './types';

import style from './NumberCard.scss';

export const NumberCard: React.FC<TNumberCardProps> = ({ numberCard, classNames = {} }) => {
    const t = useTranslations('playtech.mobile.system.registration.joinNow.');
    const buildCls = clsb([style, classNames]);

    return (
        <div className={buildCls(['card'])}>
            <div className={buildCls(['cardNumber'])}>
                {numberCard || <I18n t={t} tKey="numberCard" />}
            </div>
        </div>
    );
};
